import type { ComponentType } from "react"
import Joyride, { type CallBackProps, type Step } from "react-joyride"
import type { TooltipRenderProps } from "react-joyride"

type JoyrideLocale = Readonly<{
    back?: string
    close?: string
    last?: string
    next?: string
    nextLabelWithProgress?: string
    open?: string
    skip?: string
}>

export type StandardTourProps = Readonly<{
    steps: Step[]
    run: boolean
    stepIndex: number
    callback: (data: CallBackProps) => void
    locale: JoyrideLocale
    tooltipComponent: ComponentType<TooltipRenderProps>
}>

export function StandardTour({ steps, run, stepIndex, callback, locale, tooltipComponent }: StandardTourProps) {
    return (
        <Joyride
            steps={steps}
            run={run}
            stepIndex={stepIndex}
            callback={callback}
            continuous
            showSkipButton
            spotlightClicks={false}
            disableOverlayClose
            locale={locale}
            styles={{
                options: {
                    zIndex: 1400,
                },
            }}
            tooltipComponent={tooltipComponent}
        />
    )
}
